import { enIN } from 'date-fns/locale';
import { Field, Formik, Form as FormikForm } from 'formik';
import React, { useState, useEffect } from 'react';
import { Button, Col, Dropdown, Form, Row } from 'react-bootstrap';
import { registerLocale } from 'react-datepicker';
import { getUserTypeOptions } from '../../../constants/constants';
import validAllowedCharacters from '../../../constants/valid-character-password';
import { UserFilterInitialState } from '../../../core/initialState/filter-initial-state';
import { getUserType } from '../../../helpers/localstorage-helper';
import { IUserFilter } from '../../../models/IUserFilter';
import FormikFormInput from '../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormSelect from '../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import {
  ClearFilterIcon,
  FilterIcon,
} from '../../../shared-components/svgs/svgs';
import { formatMessage } from '../../../translations/format-message';

registerLocale('en-IN', enIN);

import { IOption } from '../../../models/ICommon';
import { getTenantIdFromLocalStorage } from '../../../helpers/localstorage-helper';

interface IProps {
  initialValues: any;
  id: number;
  submitHandler: (data: any) => void;
  filterParmas: (data: any, isfilterCleard: boolean) => void;
  onModalClosed: () => void;
  isLoading: boolean;
  isDisable: boolean;
  isFilterCleared: boolean;
  isFilterApplied: boolean;
  setIsFilterApplied: (status: boolean) => void;
  tenantBlankOptions: IOption[];
}
const FilterComponent = (props: IProps) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const handleToggle = (isOpen: boolean, resetForm: () => void) => {
    if (!isOpen) {
      resetForm();
    }
    setShowDropdown(isOpen);
  };

  function getLocalISODate(isoDate: Date) {
    return (
      isoDate.getFullYear() +
      '-' +
      String(isoDate.getMonth() + 1).padStart(2, '0') +
      '-' +
      String(isoDate.getDate()).padStart(2, '0') +
      'T' +
      String(isoDate.getHours()).padStart(2, '0') +
      ':' +
      String(isoDate.getMinutes()).padStart(2, '0') +
      ':' +
      String(isoDate.getSeconds()).padStart(2, '0')
    );
  }

  function transformQuery(input: string): string {
    const params = new URLSearchParams(input);
    const startDate = params.get('startDate')
      ? new Date(params.get('startDate') || '')
      : null;
    const endDate = params.get('endDate')
      ? new Date(params.get('endDate') || '')
      : null;
    const name = params.get('name') || '';
    const skuList = (params.get('sku') || '')
      .split(',')
      .filter((sku) => sku.trim() !== '');

    // Helper to format date to 'YYYY-MM-DD HH:mm:ss' for SQL-like query
    // const formatDate = (date: Date) =>
    //   getLocalISODate(date).slice(0, 19).replace("T", " ");

    const formatDate = (date: Date) => getLocalISODate(date).slice(0, 10);

    let queryParts: string[] = [];

    // Add name filter if 'name' is not empty
    if (name) {
      queryParts.push(`name ILIKE '%${name}%'`);
    }

    // Add SKU filter if skuList is not empty
    if (skuList.length > 0) {
      queryParts.push(
        `LOWER(D.sku) IN (${skuList.map((sku) => `'${sku.trim().toLowerCase()}'`).join(',')})`
      );
    }

    // Add date filters if startDate and endDate are valid
    if (startDate) {
      queryParts.push(`DATE(added_date)  >= '${formatDate(startDate)}'`);
    }
    if (endDate) {
      queryParts.push(`DATE(added_date)  <= '${formatDate(endDate)}'`);
    }

    // Combine all parts with "AND" and return as a single string
    return `${queryParts.join(' AND ')}`;
  }

  return (
    <React.Fragment>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        // validationSchema={FilterValidationSchema}
        validateOnBlur={false}
        onSubmit={async (values: IUserFilter, { resetForm, setFieldValue }) => {
          const selectedFactory = props.tenantBlankOptions.find(
            (opt) => opt.id === Number(values.FactoryName)
          );
          props.submitHandler({
            ...values,
            FactoryName:
              selectedFactory?.id === -1 ? '' : selectedFactory?.value || '',
          });
          setShowDropdown(false);
          props.setIsFilterApplied(true);
        }}
      >
        {({ dirty, resetForm, setFieldValue, values }) => {
          useEffect(() => {
            const isFactorySelected =
              values.FactoryName !== undefined &&
              values.FactoryName !== null &&
              values.FactoryName !== '' &&
              values.FactoryName !== -1 &&
              values.FactoryName !== '-1';

            if (
              isFactorySelected &&
              (Number(values.UserType) === 0 || Number(values.UserType) === 1)
            ) {
              setFieldValue('UserType', -1);
            }
          }, [values.FactoryName, values.UserType, setFieldValue]);

          return (
            <Dropdown
              className={`Filter-DID ${props.isDisable ? 'disabled-li' : ''}`}
              show={showDropdown}
              onToggle={(isOpen) => handleToggle(isOpen, resetForm)}
            >
              <Dropdown.Toggle
                className={`btn btn-light ${props.isFilterApplied ? 'btn-filter-disable' : 'btn-filter'}`}
                aria-expanded="false"
                title={formatMessage('filter')}
              >
                {/* <FilterIcon /> */}
                {!props.isFilterApplied ? (
                  <FilterIcon isDisable={props.isDisable} />
                ) : (
                  <ClearFilterIcon
                    onClick={(e) => {
                      // props.filterParmas({ ...UserFilterInitialState }, true);
                      resetForm();
                      setShowDropdown(!showDropdown);
                      // props.setIsFilterApplied(!props.isFilterApplied);
                    }}
                  />
                )}
              </Dropdown.Toggle>
              <FormikForm className="user-form">
                {props.isLoading ? (
                  <FormLoader loading={props.isLoading} />
                ) : null}
                <Dropdown.Menu className="filter-menu">
                  <Dropdown.ItemText className="p-0">
                    <Form.Group controlId="dateRange">
                      <div
                        className={`filter-header border-bottom p-3 px-4 ${props.isFilterCleared ? '' : ''}`}
                      >
                        <h4>
                          {formatMessage('filter')}
                          <a
                            className="clear-filter float-end"
                            onClick={() => {
                              resetForm();
                              setShowDropdown(false);
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-x"
                              viewBox="0 0 16 16"
                            >
                              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"></path>
                            </svg>
                          </a>
                        </h4>
                      </div>
                      <Row className="p-3 px-4">
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style col-form-label"
                              // required={!toggleFactoryField}
                              label="factory"
                            />
                            <Field
                              name="FactoryName"
                              as={FormikFormSelect}
                              disabled={getTenantIdFromLocalStorage() !== '-1'}
                              options={props.tenantBlankOptions}
                              // setDefaultValue={true}
                              className="form-control"
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="user_type"
                              htmlFor="UserType"
                            />
                            {/* <Field
                              data-testid="Name"
                              className="form-control"
                              name="UserType"
                              autoComplete="off"
                              placeholder=""
                              as={FormikFormInput}
                            /> */}
                            <Field
                              name="UserType"
                              as={FormikFormSelect}
                              options={
                                (values.FactoryName !== undefined &&
                                values.FactoryName !== null &&
                                values.FactoryName !== '' &&
                                values.FactoryName !== -1 &&
                                values.FactoryName !== '-1')
                                  ? getUserTypeOptions(getUserType()).filter(
                                      (option) => option.id !== 0 && option.id !== 1
                                    )
                                  : getUserTypeOptions(getUserType())
                              }
                              className="form-control"
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="form-group">
                            <Label
                              className="label-style  col-form-label"
                              required={false}
                              label="UserName"
                            />
                            <Field
                              data-testid="Name"
                              className="form-control"
                              name="UserName"
                              autoComplete="off"
                              type="text"
                              placeholder=""
                              validcharacter={validAllowedCharacters}
                              as={FormikFormInput}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <Label
                            className="label-style  col-form-label"
                            required={false}
                            label="user_id"
                            htmlFor="UserId"
                          />
                          <Field
                            data-testid="Name"
                            className="form-control"
                            name="UserId"
                            autoComplete="off"
                            placeholder=""
                            as={FormikFormInput}
                            validcharacter={validAllowedCharacters}
                          />
                        </Col>
                      </Row>
                    </Form.Group>
                  </Dropdown.ItemText>
                  <Dropdown.Divider className="mb-0" />
                  <div className="d-flex filter-btn p-3 px-4 justify-content-between align-items-center">
              <div style={{ visibility: props.isFilterCleared ? 'hidden' : 'visible' }}>
                      <Button
                        className="clear-filter float-end"
                        onClick={() => {
                          props.filterParmas(UserFilterInitialState, true);
                          setFieldValue('StartDate', null);
                          setFieldValue('EndDate', null);
                          resetForm();
                          setShowDropdown(false);
                          props.setIsFilterApplied(false);
                        }}
                      >
                        {formatMessage('clear_all_filters')}
                      </Button>
                    </div>
                    <Button
                      variant="secondary"
                      type="submit"
                      className=""
                      disabled={
                        JSON.stringify(props.initialValues) ===
                          JSON.stringify(values) ||
                        (!values.UserName &&
                          !values.UserId &&
                          (values.FactoryName === '-1' ||
                            !values.FactoryName) &&
                          (values.UserType === '-1' || !values.UserType))
                      }
                    >
                      {formatMessage('apply')}
                    </Button>
                    {/* <Button
                      variant="secondary"
                      className="mt-3"
                      onClick={() => {
                        props.filterParmas(
                          {
                            ProductName: "",
                            Sku: "",
                            StartDate: "",
                            EndDate: "",
                          },
                          true
                        );
                        setFieldValue("StartDate", null);
                        setFieldValue("EndDate", null);
                        resetForm();
                      }}
                    >
                      Clear Filters
                    </Button> */}
                  </div>
                </Dropdown.Menu>
              </FormikForm>
            </Dropdown>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

export default FilterComponent;
